import CustomersTableContainer from "./CustomersTableContainer";
import CustomerTableStore from "./CustomerTableStore";

export default CustomerTableStore(CustomersTableContainer);